import PropTypes from 'prop-types'
import { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import LayoutWrapper from '../@core/layouts/components/layout-wrapper'
import LoadingSpinner from '../components/general/LoadingSpinner'
import VerticalLayout from '../containers/DefaultLayout/VerticalLayout'
import { Routes as routes } from '../routes'
import Error from '../views/pages/misc/Error'
import ProtectedRoute from './ProtectedRoute'

/**
 * A higher-order component for creating private routes that require authentication.
 * Redirects unauthenticated users to the login page.
 *
 * @param {Object} props - The props passed to the `PrivateRoute` component.
 * @param {boolean} props.isLoggedIn
 *
 * @returns {JSX.Element} The `Route` component that conditionally renders the target component or redirects to the login page.
 */
function ProtectedApp({ isLoggedIn }) {
  const unprotectedPaths = ['/grid_exports/:id/download']
  const protectedRoutes = routes.filter(route => route.path !== 'BlankLayout' && !unprotectedPaths.includes(route.path))
  const protectedPaths = protectedRoutes.map(route => route.path && route.path)
  const unprotectedRoutes = routes.filter(route => unprotectedPaths.includes(route.path))

  if (!isLoggedIn) return <Redirect to="/login" />

  return (
    <Route path={[...protectedPaths, ...unprotectedPaths]}>
      <VerticalLayout>
        <LayoutWrapper>
          <Suspense
            fallback={
              <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 134px)' }}>
                <LoadingSpinner />
              </div>
            }
          >
            <Switch>
              {unprotectedRoutes.map(route => {
                return <Route key={route.path} path={route.path} exact={route.exact} component={route.component} />
              })}
              {protectedRoutes.map(route => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    exact={route.exact}
                    render={props => {
                      return <ProtectedRoute route={route} {...props} />
                    }}
                  />
                )
              })}
              <Route path="*" component={Error} />
            </Switch>
          </Suspense>
        </LayoutWrapper>
      </VerticalLayout>
    </Route>
  )
}

ProtectedApp.propTypes = {
  isLoggedIn: PropTypes.bool
}

export default ProtectedApp
